// เตรียม Computer ID ของร้านนี้ (computerUuid_{storeId}) แล้วชี้ `computerUuid`
// เดิมไปที่ ID นี้ ต้องเสร็จก่อน seatBlock ที่อ่าน key เดิม
// ลำดับ boot (pre ทั้งหมด): computerIdentity → runModeMigration → seatBlock (modules/seat)
// และก่อน store ไหนสร้าง useLocalStorage("computerUuid", nanoid(6)) ขึ้นมาเอง
//
// ห่อ try/catch: ล้มเหลวห้ามทำให้แอปเปิดไม่ขึ้น shop.init() จะ ensure ให้อีกรอบ
import "../../../firebaseInstance";
import { resolveStoreId } from "../composables/useStoreIdentity";
import { ensureComputerIdentity } from "../composables/useComputerIdentity";
import { DEVICE_BLOCKED_KEY } from "../../seat/utils/seatStorage";

export default defineNuxtPlugin({
  name: "computer-identity",
  enforce: "pre",
  parallel: false,
  async setup() {
    try {
      // เครื่องที่โดนบล็อกแล้ว ไม่ต้องรอ auth/network — ปล่อยให้ seatBlock
      // เด้งไป /seat/blocked.html ทันที ไม่ใช่รอ resolveStoreId() ถึง 8 วิตอน offline
      if (localStorage.getItem(DEVICE_BLOCKED_KEY)) return;

      const storeId = await resolveStoreId();
      // ยังไม่ login — ยังไม่รู้ว่าร้านไหน
      if (!storeId) return;

      ensureComputerIdentity(storeId);
    } catch (error) {
      console.warn("[computerId] เตรียม Computer ID ไม่สำเร็จ", error);
    }
  },
});
